import { Component, OnInit, HostListener } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TranslationService } from 'src/app/shared/i18n/translation.service';

interface LanguageFlag {
  lang: string;
  name: string;
  flag: string;
  active?: boolean;
}

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
})
export class LanguageSelectorComponent implements OnInit {
  isOpen = false;

  language: LanguageFlag = { lang: 'ar', name: 'العربية', flag: './assets/008-saudi-arabia.svg' };

  languages: LanguageFlag[] = [
    { lang: 'ar',  name: 'العربية', flag: './assets/008-saudi-arabia.svg' },
    { lang: 'en',  name: 'English', flag: './assets/226-united-states.svg' },
    { lang: 'tr',  name: 'Türkçe',  flag: './assets/006-turkey.svg' },
  ];

  constructor(
    private translationService: TranslationService,
    private router: Router
  ) {}

  ngOnInit() {
    this.setSelectedLanguage();
    this.router.events
      .pipe(filter(e => e instanceof NavigationStart))
      .subscribe(() => this.setSelectedLanguage());
  }

  /** Close dropdown on outside click */
  @HostListener('document:click', ['$event'])
  onDocumentClick(e: MouseEvent) {
    const el = (e.target as HTMLElement).closest('app-language-selector');
    if (!el) this.isOpen = false;
  }

  select(lang: string) {
    this.isOpen = false;
    this.setLanguage(lang);
    document.documentElement.setAttribute('lang', lang);
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    window.location.reload();
  }

  setLanguage(lang: string) {
    this.languages.forEach(l => {
      l.active = l.lang === lang;
      if (l.active) this.language = l;
    });
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    this.translationService.setLanguage(lang);
  }

  setSelectedLanguage() {
    this.setLanguage(this.translationService.getSelectedLanguage());
  }

  trackByLang(_: number, l: LanguageFlag) { return l.lang; }
}
